// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import ESIGN_GIF_RESCALED from "../../../../assets/Esign-GIF-Rescaled.gif";

class EsignWarning extends Component {
  state = {};

  _closePopup = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        {/* ----------- Modal Heading Section ----------- */}
        <div className="emptysigner-popup-wrapper">
          <div className="emptysigner-popup-body">
            <div
              className="emptysigner-popup-header"
              data-test="emptysigner-modal-heading">
              <span>
                <FontAwesomeIcon
                  className="emptysigner-popup-exclamation-icon"
                  icon={["fas", "exclamation-triangle"]}
                />
                You have not added signature blocks or signer details
              </span>
            </div>
            <div className="emptysigner-subheading">
              Please ensure that document has signer blocks and that each one is
              assigned to a recipient.
            </div>
            <div className="emptysigner-popup-title">
              Request eSignature in three easy steps
            </div>
            <div className="emptysigner-body-wrapper">
              <div className="emptysigner-popup-content-section">
                <ol>
                  <li className="emptysigner-popup-info-list">
                    Add signature blocks in the document if they are not already
                    present.
                  </li>
                  <li className="emptysigner-popup-info-list">
                    Enter signer details such as email address, first name, last
                    name in signer tags and click{" "}
                    <strong>Add new signer</strong>.
                  </li>
                  <li className="emptysigner-popup-info-list">
                    Click <strong>Get eSign</strong> to initiate eSign process.
                  </li>
                </ol>
              </div>
              <div className="emptysigner-body-image-wrapper">
                <img
                  src={ESIGN_GIF_RESCALED}
                  alt="form-mode-check"
                  className="emptysigner-body-image"
                />
              </div>
            </div>
          </div>

          <div className="emptysigner-popup-footer">
            <Button
              className="revv-btn-primary"
              data-test="emptysigner-back-btn"
              onClick={this._closePopup}>
              Back to document
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EsignWarning;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/EsignWarning/index.js